'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavbarComponent = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavbarComponent = exports.NavbarComponent = function NavbarComponent(Auth) {
  'ngInject';

  _classCallCheck(this, NavbarComponent);

  this.menu = [];
  this.isCollapsed = true;
  this.isLoggedIn = Auth.isLoggedInSync;
  this.isAdmin = Auth.isAdminSync;
  this.getCurrentUser = Auth.getCurrentUserSync;
};

exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
  template: require('./navbar.html'),
  controller: NavbarComponent
}).name;


// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js